const TYPING_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export const isTypingTarget = (target) => {
  if (!target) return false;
  const tag = String(target.tagName || '').toUpperCase();
  if (TYPING_TAGS.has(tag)) return true;
  if (target.isContentEditable) return true;
  return Boolean(target.closest?.('[contenteditable="true"]'));
};

export const isAppModalOpen = () => Boolean(document.querySelector('[data-app-modal="true"]'));

export const isAppleOs = () => {
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.platform || '';
  const ua = navigator.userAgent || '';
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS|iPhone|iPad/i.test(ua);
};

/** ⌘ on Apple, Ctrl on Windows/Linux — never both, so copy/paste still works on Mac. */
export const isModKey = (event) => {
  if (isAppleOs()) return Boolean(event.metaKey) && !event.ctrlKey;
  return Boolean(event.ctrlKey) && !event.metaKey;
};

export const isAltKey = (event) =>
  Boolean(event.altKey) && !event.ctrlKey && !event.metaKey;

export const eventLetter = (event) => {
  const code = String(event.code || '');
  if (/^Key[A-Z]$/i.test(code)) return code.slice(3).toLowerCase();
  const key = String(event.key || '');
  if (key.length === 1 && /[a-z]/i.test(key)) return key.toLowerCase();
  return '';
};

export const eventDigit = (event) => {
  const code = String(event.code || '');
  const digitMatch = code.match(/^Digit([0-9])$/);
  if (digitMatch) return digitMatch[1];
  const key = String(event.key || '');
  if (/^[1-9]$/.test(key)) return key;
  return '';
};

export const modLabel = () => (isAppleOs() ? '⌘' : 'Ctrl');
export const altLabel = () => (isAppleOs() ? '⌥' : 'Alt');

export const shortcutLabel = (parts) => parts.filter(Boolean).join('+');
